import { Middleware } from "@reduxjs/toolkit";
import { Store } from "redux";

const authChannel =
  typeof BroadcastChannel !== "undefined"
    ? new BroadcastChannel("cabinet_auth")
    : null;

let suppressBroadcast = false;

export const authSyncMiddleware: Middleware = () => (next) => (action: any) => {
  const result = next(action);
  if (
    authChannel &&
    !suppressBroadcast &&
    (action?.type === "auth/setAuth" || action?.type === "auth/removeAuth")
  ) {
    authChannel.postMessage(action);
  }
  return result;
};

export const subscribeAuthSync = (store: Store) => {
  if (!authChannel) return;
  authChannel.onmessage = ({ data }) => {
    if (data?.type) {
      suppressBroadcast = true;
      store.dispatch(data);
      suppressBroadcast = false;
    }
  };
};
